<template>
  <b-card>
    <form-component :wholesale-representative="wholesaleRepresentative" @onSubmit="onSubmit" />
  </b-card>
</template>

<script>
import FormComponent from '@/components/wholesale-representatives/FormComponent';
import NotificationMixin from '@/mixins/NotificationMixin';
import { create } from '@/http/wholesale-representatives';

export default {
  mixins: [NotificationMixin],
  components: {
    FormComponent,
  },

  data() {
    return {
      wholesaleRepresentative: {
        id: '',
        name: '',
        surname: '',
        email: '',
        countries: [],
      },
    };
  },

  methods: {
    async onSubmit(form) {
      try {
        await create(form);
        this.showSuccessNotification('Dane zapisane', 'Przedstawiciel zagraniczny został dodany.');
        this.$router.push({ name: 'wholesale-representatives-index' });
      } catch (error) {
        const message =
          error.response.data.message ??
          'Wystąpił błąd podczas dodawania przedstawiciela zagranicznego. Skontaktuj się ze swoim developerem.';

        this.showErrorNotification('Problem z zapisaniem danych', message);
      }
    },
  },
};
</script>
